import React, { forwardRef, useState, MouseEvent } from "react";
import ButtonComponent from "../ButtonComponent";
import { Menu, MenuItem } from "@mui/material";
import { BUTTON_TYPES } from "../../constants/globalVariable";
import { GoChevronDown } from "react-icons/go";

interface DropdownItem {
  id: string | number;
  text: string;
}

interface DropdownButtonComponentProps {
  items: DropdownItem[];
  content: React.ReactNode;
  select: (id: string | number) => void;
  buttonType?: (typeof BUTTON_TYPES)[keyof typeof BUTTON_TYPES];
  disabled?: boolean;
}

const DropdownButtonComponent = forwardRef<HTMLDivElement, DropdownButtonComponentProps>(
  ({ items, content, select, buttonType = BUTTON_TYPES.BACKGROUND_BUTTON, disabled }, ref) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleSelect = (id: string | number) => {
      select(id);
      handleClose();
    };

    return (
      <div ref={ref}>
        <ButtonComponent
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          buttonType={buttonType}
          disabled={disabled}
          endIcon={<GoChevronDown />}
        >
          {content}
        </ButtonComponent>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          slotProps={{
            list: {
              "aria-labelledby": "basic-button",
            },
          }}
        >
          {items.map((item: DropdownItem, index: number) => (
            <MenuItem key={index} onClick={() => handleSelect(item.id)}>
              {item.text}
            </MenuItem>
          ))}
        </Menu>
      </div>
    );
  },
);

DropdownButtonComponent.displayName = "DropdownButtonComponent";

export default DropdownButtonComponent;
